/* eslint-disable max-len */
import React from "react";

export const InfoIcon: React.FC = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10670_194108)">
        <path d="M11.3241 7H13.3831V9H11.3241V7ZM11.3241 11H13.3831V17H11.3241V11ZM12.3536 2C6.67089 2 2.05884 6.48 2.05884 12C2.05884 17.52 6.67089 22 12.3536 22C18.0363 22 22.6484 17.52 22.6484 12C22.6484 6.48 18.0363 2 12.3536 2ZM12.3536 20C7.81361 20 4.11779 16.41 4.11779 12C4.11779 7.59 7.81361 4 12.3536 4C16.8936 4 20.5894 7.59 20.5894 12C20.5894 16.41 16.8936 20 12.3536 20Z" fill="#2B3337"/>
      </g>
      <defs>
        <clipPath id="clip0_10670_194108">
          <rect width="24.7074" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};
